export default __webpack_public_path__ + "static/media/lama.d48357bc.JPG";